import { UserBasic } from '../../../../lib/functions/user'

type ProgramAssignment = {
  programManager?: UserBasic
  collaborators: UserBasic[]
  added?: boolean
}

export const isProgramAssignee = (
  program: ProgramAssignment,
  currentUserUuid: string | undefined
): boolean => {
  if (!currentUserUuid) return false
  return (
    program.programManager?.uuid === currentUserUuid ||
    program.collaborators.some(
      collaborator => collaborator.uuid === currentUserUuid
    )
  )
}

export const isProgramEditable = (
  program: ProgramAssignment,
  currentUserUuid: string | undefined,
  isAdmin: boolean
): boolean =>
  !!program.added || isAdmin || isProgramAssignee(program, currentUserUuid)

export const isProgramTransitionVisible = (
  program: ProgramAssignment,
  currentUserUuid: string | undefined,
  isAdmin: boolean
): boolean => isAdmin || isProgramAssignee(program, currentUserUuid)
